import { useMemo } from 'react';

import { AccessPermissions } from 'core/enums';

import { useAuthUser } from './auth';

const LLM_ACCESS_USER_IDS = [40];

export const useUserPermissions = () => {
  const { user } = useAuthUser();

  const hasLlmAccess = useMemo(() => {
    return LLM_ACCESS_USER_IDS.includes(user?.id);
  }, [user]);

  const hasPermission = useMemo(
    () => (permission: AccessPermissions) => {
      return user?.resources.includes(permission) ?? false;
    },
    [user]
  );

  return {
    hasLlmAccess,
    hasPermission,
  };
};
